var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"formButtonSubmit"},[_c('button',{staticClass:"loginbtn primaryBtn",attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('span',{staticClass:"loader"}):_c('span',[_vm._v(_vm._s(_vm.buttonText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }